'use client';
import React, { useState } from 'react';

export default function HeroSection() {
  const [propertyType, setPropertyType] = useState('');
  const [location, setLocation] = useState('');
  const [plotSize, setPlotSize] = useState('');
  const [budget, setBudget] = useState('');

  const handleExplore = () => {
    const params = new URLSearchParams();
    
    // Map Property Type
    if (propertyType) {
      let mappedType = propertyType;
      if (propertyType === 'commercial') mappedType = 'Commercial';
      if (propertyType === 'freehold') mappedType = 'Freehold';
      if (propertyType === 'industrial') mappedType = 'Industrial';
      if (propertyType === 'mixed') mappedType = 'Mixed-Use';
      if (propertyType === 'residential' || propertyType === 'residential-plots') mappedType = 'Residential';
      if (propertyType === 'retail') mappedType = 'Retail';
      params.set('type', mappedType);
    }
    
    // Map Location
    if (location) {
      let mappedLoc = location;
      if (location === 'al-marjan') mappedLoc = 'Al Marjan';
      if (location === 'bu-kadra') mappedLoc = 'Meydan';
      if (location === 'business-bay') mappedLoc = 'Business Bay';
      if (location === 'city-of-arabia') mappedLoc = 'City of Arabia';
      if (location === 'dic') mappedLoc = 'DIC';
      if (location === 'dlrc') mappedLoc = 'DLRC';
      if (location === 'downtown') mappedLoc = 'Downtown';
      if (location === 'dubai-industrial') mappedLoc = 'Dubai Industrial';
      if (location === 'dubai-island') mappedLoc = 'Dubai Islands';
      if (location === 'dubai-land') mappedLoc = 'Dubai Land';
      if (location === 'jvc') mappedLoc = 'JVC';
      if (location === 'jvt') mappedLoc = 'JVT';
      if (location === 'majan') mappedLoc = 'Majan';
      if (location === 'mbr-city') mappedLoc = 'MBR City';
      if (location === 'pearl-jumeirah') mappedLoc = 'Pearl Jumeirah';
      if (location === 'sports-city') mappedLoc = 'Sports City';
      params.set('location', mappedLoc);
    }
    
    // Map Plot Size
    if (plotSize && plotSize !== 'any') {
      if (plotSize === '500-1000') {
        params.set('minArea', '500');
        params.set('maxArea', '1000');
      } else if (plotSize === '1000-5000') {
        params.set('minArea', '1000');
        params.set('maxArea', '5000');
      } else if (plotSize === '5000-10000') {
        params.set('minArea', '5000');
        params.set('maxArea', '10000');
      } else if (plotSize === '10000-50000') {
        params.set('minArea', '10000');
        params.set('maxArea', '50000');
      } else if (plotSize === '50000-100000') {
        params.set('minArea', '50000');
        params.set('maxArea', '100000');
      } else if (plotSize === '100000+') {
        params.set('minArea', '100000');
      }
    }
    
    // Map Budget
    if (budget && budget !== 'any') {
      if (budget === '1m') params.set('maxPrice', '1000000');
      else if (budget === '5m') params.set('maxPrice', '5000000');
      else if (budget === '10m') params.set('maxPrice', '10000000');
      else if (budget === '50m') params.set('maxPrice', '50000000');
      else if (budget === '100m') params.set('maxPrice', '100000000');
    }
    
    window.location.href = `/search?${params.toString()}`;
  };

  return (
    <section
      className="relative w-full min-h-[900px] flex items-center"
      style={{
        backgroundImage: 'url(/uploads/Plotae-Web-Banner-1200x900-1.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 w-full">
        <div className="pt-24 pb-16">
          <div className="max-w-[600px]">
            {/* Heading */}
            <h1
              className="text-[72px] lg:text-[115px] font-normal leading-[1.0] text-black mb-6"
              style={{ fontFamily: '"Times New Roman", serif' }}
            >
              Invest Smart with Land
            </h1>

            {/* Subtitle */}
            <p className="text-[16px] text-[#50514f] mb-10 max-w-[480px] leading-relaxed">
              <span className="font-semibold">
                Your trusted gateway to intelligent, verified land deals
              </span>{' '}
              <span>powered by the</span> UAE&apos;s premier real estate agency.
            </p>
          </div>

          {/* Search Form */}
          <div className="flex flex-wrap lg:flex-nowrap gap-2 items-center max-w-[850px] w-full">
            {/* Property Type */}
            <div className="relative">
              <select
                value={propertyType}
                onChange={(e) => setPropertyType(e?.target?.value)}
                className="appearance-none bg-none bg-white border border-gray-200 rounded-lg pl-4 pr-8 py-3 text-[13px] text-gray-500 cursor-pointer focus:outline-none focus:border-[#017743] min-w-[130px]"
              >
                <option value="">Type</option>
                <option value="commercial">Commercial Plots for Sale</option>
                <option value="freehold">Freehold</option>
                <option value="industrial">Industrial Plots for Sale</option>
                <option value="mixed">Mixed-Use Land for Sale</option>
                <option value="projects">Projects</option>
                <option value="residential">Residential</option>
                <option value="residential-plots">Residential Plots for Sale</option>
                <option value="retail">RETAIL</option>
              </select>
              <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            {/* Location */}
            <div className="relative">
              <select
                value={location}
                onChange={(e) => setLocation(e?.target?.value)}
                className="appearance-none bg-none bg-white border border-gray-200 rounded-lg pl-4 pr-8 py-3 text-[13px] text-gray-500 cursor-pointer focus:outline-none focus:border-[#017743] min-w-[130px]"
              >
                <option value="">Area</option>
                <option value="al-marjan">Al Marjan Island</option>
                <option value="bu-kadra">BU KADRA-MEYDAN</option>
                <option value="business-bay">BUSINESS BAY</option>
                <option value="city-of-arabia">CITY OF ARABIA</option>
                <option value="dic">DIC</option>
                <option value="dlrc">DLRC</option>
                <option value="downtown">DOWNTOWN</option>
                <option value="dubai-industrial">Dubai Industrial City</option>
                <option value="dubai-island">DUBAI ISLAND</option>
                <option value="dubai-land">DUBAI LAND</option>
                <option value="jvc">JVC</option>
                <option value="jvt">JVT</option>
                <option value="majan">MAJAN</option>
                <option value="mbr-city">MBR City</option>
                <option value="pearl-jumeirah">Pearl Jumeirah</option>
                <option value="sports-city">SPORTS CITY</option>
              </select>
              <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            {/* Plot Size */}
            <div className="relative">
              <select
                value={plotSize}
                onChange={(e) => setPlotSize(e?.target?.value)}
                className="appearance-none bg-none bg-white border border-gray-200 rounded-lg pl-4 pr-8 py-3 text-[13px] text-gray-500 cursor-pointer focus:outline-none focus:border-[#017743] min-w-[130px]"
              >
                <option value="">Plot Size</option>
                <option value="500-1000">500-1000 sq.ft</option>
                <option value="1000-5000">1000-5000 sq.ft</option>
                <option value="5000-10000">5000-10000 sq.ft</option>
                <option value="10000-50000">10000-50000 sq.ft</option>
                <option value="50000-100000">50000-100000 sq.ft</option>
                <option value="100000+">100000+ sq.ft</option>
                <option value="any">Any</option>
              </select>
              <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            {/* Budget */}
            <div className="relative">
              <select
                value={budget}
                onChange={(e) => setBudget(e?.target?.value)}
                className="appearance-none bg-none bg-white border border-gray-200 rounded-lg pl-4 pr-8 py-3 text-[13px] text-gray-500 cursor-pointer focus:outline-none focus:border-[#017743] min-w-[130px]"
              >
                <option value="">Max.Price</option>
                <option value="1m">AED 1,000,000</option>
                <option value="5m">AED 5,000,000</option>
                <option value="10m">AED 10,000,000</option>
                <option value="50m">AED 50,000,000</option>
                <option value="100m">AED 100,000,000</option>
                <option value="any">Any</option>
              </select>
              <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            {/* Explore Button */}
            <button
              onClick={handleExplore}
              className="bg-[#017743] text-[#ffffff] font-semibold text-[14px] px-8 py-3 rounded-full hover:bg-[#015c33] transition-colors duration-200"
            >
              Explore
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
